<template>
  <div class="page-template" v-loading="loading">
    <!--    <div class="page-title">{{ title }}</div>-->
    <el-tabs v-model="activeTab" @tab-click="tabChange">
      <el-tab-pane label="商品做法" name="recipe">
        <search-form-template
          :searchOptions="recipeSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="recipeConfig"
          @btnCommon="btnCommon"
        ></search-form-template>
        <table-template ref="recipe" :tableOptions="recipeTable" :toolConfig="recipeToolConfig"></table-template>
      </el-tab-pane>
      <el-tab-pane label="关联商品" name="goods">
        <search-form-template
          :searchOptions="goodsSearchOptions"
          @searchSubmit="searchSubmit"
          @clear="clearSearch"
          :toolConfig="goodsConfig"
          @btnCommon="btnCommon"
        ></search-form-template>
        <table-template ref="goods" :tableOptions="goodsTable" :toolConfig="goodsToolConfig"></table-template>
      </el-tab-pane>
    </el-tabs>

    <!--新增做法弹框-->
    <el-dialog
      title="商品做法"
      @closed="clearData"
      :visible.sync="dialogVisibility"
      center
      custom-class="category-dialog"
      width="900px"
      height="800"
    >
      <div class="column-title">基本信息</div>
      <div>
        <span>&nbsp;&nbsp;&nbsp;&nbsp;做法规格：</span>
        <el-input v-model.trim="model.name" :maxlength="32"
                  placeholder='规格名称不能为空' :disabled="nameDisabled"></el-input>
      </div>
      <div class="column-title">做法</div>
      <div class="com-item">
        <list-operation v-if="dialogVisibility" ref="recipeListOperation"
                        :tableOptions="recipeColumns"></list-operation>
      </div>
      <div class="btn-box">
        <el-button type="primary" @click="submitData">提交</el-button>
      </div>
    </el-dialog>

    <!--关联商品弹框-->
    <el-dialog
      title="关联商品"
      :visible.sync="recipeGoodsAddShow"
      center
      custom-class='timedSpecialsBox'
      height="1500px"
      width="800px"
      :before-close="closeDialog"
    >
      <el-form ref="timeSpcecailsForm" label-width="10%" :rules="rules" :model="timeSpcecailsFormData">
        <el-collapse v-model="activeName">
          <!-- 折叠面板一 -->
          <div class="column-title">基本信息</div>
          <el-form-item label='商品信息' prop="activityName">
            <div class="search-goods-box">
              <el-input id="goodsText"
                        ref="goodsInput"
                        placeholder="条码/自编码/助记码"
                        v-model="goodsTxt"
                        class="search-goods-input"
                        @change="search"
                        :disabled="goodsTextCheck"
              >
                <template slot="prepend">
                  <span>综合搜索</span>
                </template>
                <template slot="append">
                  <div class="el-icon-search more-btn"></div>
                </template>
              </el-input>
              <el-button @click="checkGoods" type="primary" plain class="select-good" :disabled="goodsTextCheck"
              >选择商品
              </el-button>
            </div>
          </el-form-item>
          <list-operation v-if="recipeGoodsAddShow" ref="recipeGoodsListOperation"
                          :tableOptions="recipeGoodsAddColumns"></list-operation>
          <!-- 折叠面板二 -->
          <div class="column-title">关联做法</div>
          <el-input v-model="recipeName" placeholder='做法内容搜索' :disabled="goodsTextCheck">
            <el-button slot="append" icon="el-icon-search" @click="getRecipe" :disabled="goodsTextCheck"></el-button>
          </el-input>
          <list-operation ref="recipeOperation" :tableOptions="recipeGoodsColumns"
                          @selectRowChange="selectShowChange"></list-operation>
        </el-collapse>
      </el-form>
      <div class="footerBtn">
        <el-button type='primary' @click="saveRecipeGoods()">保存</el-button>
        <el-button type='default' @click="reset()" :disabled="goodsTextCheck">重置</el-button>
      </div>
    </el-dialog>

    <!--商品列表-->
    <el-dialog title="商品列表" :visible.sync="goodsListShow" width="1200px" height="800"
               :close-on-click-modal="false">
      <good-list
        v-if="goodsListShow"
        ref="goodsListOperation"
        @rowCheck="rowCheck"
        :isSelect="goodListSelect"
        :tableOptions="tableOptions"
        :otherParam="otherParam"
        @selectSubmit="rowsSelectSubmit"
        :selectUrl="selectUrl"
        :listTableData="listTableData"
      ></good-list>
    </el-dialog>

  </div>
</template>

<script>
import api from "@/config/api";
import searchFormTemplate from "@/components/template/searchFormTemplate";
import tableTemplate from "@/components/template/tableTemplate";
import userPower from "@/mixin/userPower";
import listOperation from '@/components/template/listOperation';
import goodList from '@/components/business/goodList';

export default {
  mixins: [userPower],
  name: "Recipe",
  components: {
    tableTemplate,
    searchFormTemplate,
    listOperation,
    goodList,
  },
  data() {
    return {
      updateData: {},
      rowId: '',
      goodsTextCheck: false,
      isCheck: false,
      recipeList: [],
      otherParam: {statusList: [10, 20], isOpenCombination: 2},
      goodsTxt: '',
      recipeName: '',
      activeName: 'activeName',
      goodsListShow: false,
      listTableData: [],
      goodListSelect: false,
      nameDisabled: false,
      loading: false,
      dialogVisibility: false,
      recipeGoodsAddShow: false,
      selectUrl: {url: api.warehouse.warehouseGoods},
      activeTab: 'recipe',
      // 商品做法
      recipeSearchOptions: {
        simple: [
          {
            label: "",
            type: "input",
            prop: "orderNo",
            isFuzzy: true,
            placeholder: "请输入流水票号/会员名称",
          },
        ],
      },
      // 关联商品
      goodsSearchOptions: {
        simple: [
          {
            label: "",
            type: "input",
            prop: "orderNo",
            isFuzzy: true,
            placeholder: "请输入流水票号/会员名称",
          },
        ],
      },
      //商品做法
      recipeTable: {
        indexShow: true, //是否显示索引
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "做法规格",
            prop: "name",
            width: "160",
            align: "center",
          },
          {
            label: "商品数量",
            prop: "goodsCount",
            width: "100",
            align: "center",
          },
          {
            label: "创建时间",
            prop: "createDttm",
            width: "160",
            align: "center",
          },
        ],
        url: api.archives.recipe,
      },
      //商品做法
      goodsTable: {
        indexShow: true, //是否显示索引
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "商品名称",
            prop: "goodsName",
            width: "160",
            align: "center",
          },
          {
            label: "条码",
            prop: "barCode",
            width: "100",
            align: "center",
          },
          {
            label: "做法规格",
            prop: "barCodeCount",
            width: "220",
            align: "center",
          },
          {
            label: "创建时间",
            prop: "createDttm",
            width: "180",
            align: "center",
          },
        ],
        url: api.archives.goodsRecipe,
      },
      // 更多功能
      goodsConfig: [
        {
          label: "新增",
          code: "insert",
          callback: this.addRecipeGoods
        },
      ],
      recipeConfig: [
        {
          label: "新增",
          code: "insert",
          callback: this.addRecipe
        },
      ],
      // 商品做法按钮
      recipeToolConfig: [
        {
          label: '编辑',
          code: 'update',
          more: true,
          type: this.$utils.buttonType.tableOperate,
          callback: this.updateRecipe
        },
        {
          label: '删除',
          more: true,
          type: this.$utils.buttonType.tableOperate,
          code: 'delete',
          callback: this.deleteRecipe
        }
      ],
      // 商品做法按钮
      goodsToolConfig: [
        {
          label: '编辑',
          code: 'update',
          more: true,
          type: this.$utils.buttonType.tableOperate,
          callback: this.updateGoodsRecipe
        },
        {
          label: '删除',
          more: true,
          type: this.$utils.buttonType.tableOperate,
          code: 'delete',
          callback: this.deleteGoodsRecipe
        }
      ],

      model: {
        name: '',
        recipeMapList: [],
      },
      timeSpcecailsFormData: {},
      // 添加表格字段
      recipeColumns: {
        hideSum: true,
        disabled: false,
        indexShow: true, // 是否显示索引
        columns: [
          {label: '序号', type: 'index', width: 60, prop: 'idx'},
          {
            label: '内容名称',
            prop: 'name',
            type: 'input',
            width: '150',
            change: this.setInfo
          },
          {
            label: '加价',
            prop: 'price',
            type: 'input',
            width: '150',
            change: this.setInfo
          },
          {label: '操作', type: 'operation', width: 100, prop: 'operation'},
        ],
        url: api.archives.priceDadjap
      },

      // 商品信息
      recipeGoodsAddColumns: {
        hideSum: true,
        disabled: false,
        indexShow: true, // 是否显示索引
        columns: [
          {label: '序号', type: 'index', width: 60, prop: 'idx'},
          {
            label: '品名',
            prop: 'goodsName',
            width: '150',
          },
          {
            label: '条码',
            prop: 'barCode',
            width: '150',
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '150',
          },
          {
            label: '零售价',
            prop: 'retailPrice',
            width: '150',
          },
          {label: '操作', type: 'operation', width: 100, prop: 'operation'},
        ],
      },

      // 商品信息
      recipeGoodsColumns: {
        showSelect: true,
        hideSum: true,
        indexShow: true, // 是否显示索引
        columns: [
          {label: '序号', type: 'index', width: 60, prop: 'idx'},
          {
            label: '做法规格',
            prop: 'name',
            width: '150',
          },
          {
            label: '内容名称',
            prop: 'nameStr',
            width: '150',
          },
        ],
        url: api.archives.recipe
      },

      // 表格信息配置
      tableOptions: {
        indexShow: true, // 是否显示索引
        indexMethod: (index) => { // 自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '条码',
            prop: 'barCode',
            width: '210',
            align: 'center'
          },
          {
            label: '品名',
            prop: 'goodsName',
            width: '150',
            align: 'center'
          },
          {
            label: '规格',
            prop: 'specs',
            width: '80',
            align: 'center'
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '80',
            align: 'center'
          },
          {
            label: '进货价',
            prop: 'buyPrice',
            width: '150',
            align: 'center'
          },
          {
            label: '零售价',
            prop: 'retailPrice',
            width: '150',
            align: 'center'
          },
          {
            label: '库存',
            prop: 'inventoryNum',
            width: '150',
            align: 'center'
          }
        ],
        url: api.archives.goodsInfoIncludeSpecs
      },

      rules: {
        // activityName: {required: true, message: "请填写活动名称", trigger: "blur"},
      },
    };
  },
  created() {
  },
  methods: {
    // 操作回调
    btnCommon(btnObj, data) {
      btnObj.callback && btnObj.callback(data);
    },
    tabChange(val) {
      this.$refs[this.activeTab].operationSuccess();
    },
    searchSubmit(param) {
      this.$refs[this.activeTab].searchParam = param;
      this.$refs[this.activeTab].operationSuccess();
    },

    clearSearch() {
      console.log(this.$refs['cashierReport']);
      this.$refs['recipe'].clearSearch();
      this.$refs['goods'].clearSearch();
      let userInfo = this.$utils.getSysUser();
      if (!userInfo.storeId) {
        this.recipeSearchOptions.complex.filter(item => item.prop === 'guideId')[0].data = []
        this.recipeSearchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = []
        this.goodsTable.complex.filter(item => item.prop === 'guideId')[0].data = []
        this.goodsTable.complex.filter(item => item.prop === 'cashierId')[0].data = []
        this.goodsTable.complex.filter(item => item.prop === 'supplierId')[0].data = []
        this.goodsTable.complex.filter(item => item.prop === 'brandId')[0].data = []
      }
    },
    // 关闭弹框
    clearData() {
      this.model.name = '';
      this.dialogVisibility = false;
    },
    addRecipe() {
      this.model = {};
      this.nameDisabled = false;
      this.dialogVisibility = true;
    },
    // 失焦 获取某行数据填充
    setInfo(rowData, index) {
      if (rowData.name) {
        this.$refs['recipeListOperation'].setColumnData(rowData, index);
      }
    },
    submitData() {
      if (this.model.name === '' || this.model.name == null) {
        this.$message.warning("规格名称不能为空");
        return;
      }
      let recipeMapArray = this.$refs.recipeListOperation.getData();
      if (!recipeMapArray || recipeMapArray.length === 0) {
        this.$message.warning("请填写做法");
        return;
      }
      let recipeMapArrayFlag = false;
      recipeMapArray.map(item => {
        if (item.name === '' || item.name == null) {
          recipeMapArrayFlag = true;
          return;
        }
      });
      if (recipeMapArrayFlag) {
        this.$message.warning("做法内容格式不正确,无法保存");
        return;
      }
      this.model.recipeMapList = recipeMapArray;
      this.save();
    },
    save() {
      this.$loading({text: '提交中，请稍后。。。'});
      this.$axios[this.model.id ? "fetchPut" : "fetchPost"](api.archives.recipe, this.model).then((data) => {
        if (data.code === 200 && data.data) {
          this.$notify({
            type: "success",
            title: this.model.id ? "编辑" : "添加" + '操作',
            message: '成功',
            showClose: false,
          });
          this.clearData();
          this.model.name = '';
          this.$refs['recipe'].getTableData();
        } else {
          this.$message({message: data.msg, type: "error"});
        }
      }).finally(() => {
        this.$loading({}).close()
      })
    },
    updateRecipe(row) {
      this.nameDisabled = true;
      this.$axios.fetchGet(api.archives.recipe + "?id=" + row.id)
        .then((data) => {
          if (data.code === 200 && data.data) {
            this.dialogVisibility = true;
            this.model = data.data;
            this.$nextTick(() => {
              this.$refs.recipeListOperation.addMoreRow(data.data.recipeMapList, 0);
            });
          } else {
            this.$message({message: "获取详情出错", type: "error"});
          }
        });
    },
    deleteRecipe(row) {
      this.$confirm('是否删除?', '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '删除中，请稍候...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        this.$axios.fetchDelete(api.archives.recipe + "?id=" + row.id)
          .then((data) => {
            if (data.code === 200) {
              this.$notify({
                type: "success",
                title: '删除操作',
                message: '成功',
                showClose: false,
              });
              this.$refs['recipe'].getTableData();
            } else {
              this.$notify({
                type: "error",
                title: '删除操作',
                message: data.errorMsg,
                showClose: false,
              });
            }
          }).catch(err => {
          this.$notify({
            type: "error",
            title: '删除操作',
            message: '失败',
            showClose: false,
          });
        }).finally(() => {
          loading.close()
        })
      }).catch(() => this.$message({message: '保存取消！', type: 'info'}));
    },
    addRecipeGoods() {
      this.goodsTextCheck = false;
      this.recipeGoodsAddShow = true;
      this.getRecipe();
    },
    closeDialog() {
      this.recipeGoodsAddShow = false;
    },
    // 选择某行数据
    rowCheck(row) {
      this.goodsListShow = false;
      this.$refs['recipeGoodsListOperation'].setColumnData(row, this.checkIndex);
      this.currentTableList = this.$refs['recipeGoodsListOperation'].getTabelData();
    },
    //  多选择商品 确认
    rowsSelectSubmit(row) {
      this.goodsListShow = false;
      let tableList = this.$refs['recipeGoodsListOperation'].getTabelData();
      this.$refs['recipeGoodsListOperation'].addMoreRow(row, tableList.length);
      this.currentTableList = this.$refs['recipeGoodsListOperation'].getTabelData();
      this.$message.success("商品添加成功");
    },
    checkGoods() {
      if (!this.isCheck) {
        this.$axios.fetchPost(api.archives.goodsRecipe + '/list')
          .then((data) => {
            if (data.code === 200) {
              this.goodsListShow = true;
              this.goodListSelect = true;
              debugger
              this.listTableData = data.data;// table数据
              this.$nextTick(() => {
                this.otherParam = {...this.otherParam};
              })
            } else {
              this.$message({message: "获取详情出错", type: "error"});
            }
          });
      }
    },
    search() {
      if (this.goodsTxt === '' || this.goodsTxt === null) return;
      this.otherParam.otherName = this.goodsTxt;
      this.isCheck = true;
      this.$axios
        .fetchPost(api.warehouse.warehouseGoods + "/list", this.otherParam)
        .then(res => {
          if (res.code === 200) {
            if (res.data.length > 0) {
              let tableData = res.data;
              if (tableData.length === 1) {
                let row = tableData[0];
                let tableList = this.$refs["recipeGoodsListOperation"].getTabelData();
                let flag = true;
                if (tableList.length > 0) {
                  tableList.forEach(item => {
                    if (flag) {
                      if (item.barCode === row.barCode) flag = false;
                    }
                  });
                }
                if (!flag) {
                  this.$message.warning("[名称:" + row.goodsName + ",条码:" + row.barCode + "],已存在！！！");
                  return;
                }
                this.$refs["recipeGoodsListOperation"].setColumnData(row, tableList.length);
                this.currentTableList = this.$refs["recipeGoodsListOperation"].getTabelData();
                this.$message.success("商品添加成功");
              } else {
                this.checkGoods();
              }
            } else {
              this.$message.warning("[条码:" + this.goodsTxt + "],商品不存在！！！");
            }
          } else {
            this.$message({type: "error", message: res.msg});
          }
        })
        .catch(err => {
        }).finally(() => {
        this.isCheck = false;
        this.clearQueryParam();
      });
    },
    clearQueryParam() {
      this.goodsTxt = '';
      this.otherParam.otherName = '';
    },
    // 查询做法
    getRecipe() {
      const loading = this.$loading({
        lock: true,
        text: '删除中，请稍候...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      let param = {
        name: this.recipeName
      };
      this.$axios
        .fetchPost(api.archives.recipe + "/info/list", param)
        .then(res => {
          if (res.code === 200) {
            this.$nextTick(() => {
              this.$refs["recipeOperation"].clearTableData();
              this.$refs["recipeOperation"].addMoreRow(res.data, 0);
            });
          } else {
            this.$message({type: "error", message: res.msg});
          }
        })
        .catch(err => {
        }).finally(() => {
        this.recipeName = '';
        loading.close();
      });
    },
    saveRecipeGoods() {
      let goodsArray = this.$refs["recipeGoodsListOperation"].getTabelData();
      if (!goodsArray || goodsArray.length === 0) {
        this.$message.warning("商品列表不能为空");
        return;
      }
      if (!this.recipeList || this.recipeList.length === 0) {
        this.$message.warning("做法列表不能为空");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '保存中，请稍候...',
        background: 'rgba(225, 225, 225, 0.8)'
      });
      const obj = this.updateData;
      let param = {
        goodsList: goodsArray,
        recipeList: this.recipeList,
        goodsVo: obj
      };
      this.$axios[this.timeSpcecailsFormData.id ? "fetchPut" : "fetchPost"](api.archives.goodsRecipe, param).then((data) => {
        if (data.code === 200 && data.data) {
          this.$notify({
            type: "success",
            title: this.model.id ? "编辑" : "添加" + '操作',
            message: '成功',
            showClose: false,
          });
          this.timeSpcecailsFormData.id = '';
          this.updateData = {};
          this.recipeGoodsAddShow = false;
          this.goodsTxt = '';
          this.recipeName = '';
          this.$refs['recipeGoodsListOperation'].clearTableData();
          this.$refs['goods'].getTableData();
        } else {
          this.$message({message: data.msg, type: "error"});
        }
      }).finally(() => {
        loading.close();
      })
    },
    reset() {
      this.goodsTxt = '';
      this.recipeName = '';
      this.$refs['recipeGoodsListOperation'].clearTableData();
      this.getRecipe();
    },
    selectShowChange(row) {
      console.log(row);
      if (row && row.length > 0) {
        this.recipeList = row;
      }
    },
    updateGoodsRecipe(row) {
      // 获取全部做法
      this.$axios
        .fetchPost(api.archives.recipe + "/info/list", {})
        .then(res => {
          if (res.code === 200 && res.data.length > 0) {
            this.goodsTextCheck = true;
            this.$axios.fetchGet(api.archives.goodsRecipe + "?id=" + row.id)
              .then((data) => {
                if (data.code === 200) {
                  this.recipeGoodsAddShow = true;
                  this.timeSpcecailsFormData.id = data.data.id;
                  this.updateData = data.data.goodsVo;
                  this.$nextTick(() => {
                    let dataAry = res.data;
                    if (dataAry && dataAry.length > 0) {
                      dataAry.forEach(item => {
                        data.data.recipeList.forEach(e => {
                          if (item.id === e.id) {
                            item.selectStatus = 1;
                          }
                        });
                      });
                    }
                    this.$refs["recipeOperation"].addMoreRow(dataAry, 0);
                    this.$refs["recipeGoodsListOperation"].setColumnData(data.data.goodsVo, 0);
                  });
                  this.$nextTick(() => {
                    this.$refs["recipeOperation"].toggleSelection();
                  });
                } else {
                  this.$message({message: "获取详情出错", type: "error"});
                }
              });
          } else {
            this.$message({type: "error", message: res.msg});
          }
        })
        .catch(err => {
        }).finally(() => {
      });
    },
    deleteGoodsRecipe(row) {
      this.$confirm('是否删除?', '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '删除中，请稍候...',
          background: 'rgba(225, 225, 225, 0.8)'
        });
        this.$axios.fetchDelete(api.archives.goodsRecipe + "?id=" + row.id)
          .then((data) => {
            if (data.code === 200) {
              this.$notify({
                type: "success",
                title: '删除操作',
                message: '成功',
                showClose: false,
              });
              this.$refs['goods'].getTableData();
            } else {
              this.$notify({
                type: "error",
                title: '删除操作',
                message: data.errorMsg,
                showClose: false,
              });
            }
          }).catch(err => {
          this.$notify({
            type: "error",
            title: '删除操作',
            message: '失败',
            showClose: false,
          });
        }).finally(() => {
          loading.close()
        })
      }).catch(() => this.$message({message: '保存取消！', type: 'info'}));
    }
  }
};
</script>

<style>
.order-add-page .search-goods-box {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.order-add-page .search-goods-box .select-good {
  margin-left: 16px;
}

.search-goods-input {
  width: 300px;
}

/deep/ #goodsText {
  height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/page/archives/goods/Recipe.vue